import { RenderMode } from "./renderer/renderer";

export const RENDER_MODES: RenderMode[] = [
  "INPUT_CANVAS",
  "DISTANCE_FIELD",
  "RAW_DISTANCE_FIELD",
  "HARD_SHADOWS",
  "SOFT_SHADOWS_1",
  "SOFT_SHADOWS_2",
  "ALL",
];

type OverlayType = "none" | "lightbulb" | "ray";

interface AppLaunchInfo {
  scene:
    | {
        type: "text";
        text: string;
      }
    | {
        type: "rect";
      };

  renderModeIndex: number;
  overlayType: OverlayType;
  editText: boolean;
}

const DEFAULT_APP_LAUNCH_INFO: AppLaunchInfo = {
  scene: {
    type: "text",
    text: "Alice in wonderland",
  },
  renderModeIndex: RENDER_MODES.length - 1,
  overlayType: "none",
};

function getURLParams(search: string): Map<string, string> {
  const query = search.substr(1);
  const result = new Map<string, string>();
  query.split("&").forEach((part) => {
    var item = part.split("=");
    result.set(item[0], decodeURIComponent(item[1]));
  });
  return result;
}

function appLaunchInfo(): AppLaunchInfo {
  const appLaunchInfo = { ...DEFAULT_APP_LAUNCH_INFO };
  const urlParams = getURLParams(window.location.search);

  if (urlParams.has("text")) {
    appLaunchInfo.scene = {
      type: "text",
      text: urlParams.get("text")!,
    };
  } else if (urlParams.has("rect")) {
    appLaunchInfo.scene = {
      type: "rect",
    };
  }

  if (urlParams.has("renderMode")) {
    const renderMode = urlParams.get("renderMode")!;
    const index = RENDER_MODES.indexOf(renderMode as RenderMode);
    if (index !== -1) {
      appLaunchInfo.renderModeIndex = index;
    }
  }

  if (urlParams.has("overlay")) {
    appLaunchInfo.overlayType = urlParams.get("overlay") as OverlayType;
  }

  appLaunchInfo.editText = false;
  if (urlParams.has("editText")) {
    appLaunchInfo.editText = true;
  }

  return appLaunchInfo;
}

export const APP_LAUNCH_INFO = appLaunchInfo();
